import { useCallback } from 'react';

import { v4 as uuidV4 } from 'uuid';

import { sendEvent } from '../../../analytics-library/entry/sendEvent';
import { LegacyEvent } from '../../../analytics-library/events/LegacyEvent/LegacyEvent';
import getUrlParameters from '../../../utils/getUrlParameters';
import type { MasterWidgetProps } from '../../components/MasterWidget/MasterWidget';

import { getLegacyEventData } from './getLegacyEventData';
import { IAnalyticsMethods } from './model';

const getWidgetId = (): string => {
  // Allow forcing the ID for Cypress tests
  const { widgetId } = getUrlParameters();
  if (widgetId) {
    return widgetId;
  }

  return uuidV4();
};

export const useAnalytics = (props: MasterWidgetProps): IAnalyticsMethods => {
  const widgetId = getWidgetId();

  const sendAnalytics: IAnalyticsMethods['sendAnalytics'] = useCallback(
    ({ affiliate, category, deal, product, products, dealData }) => {
      sendEvent(
        new LegacyEvent({
          data: getLegacyEventData({
            affiliate,
            category,
            product,
            products,
            dealData,
            deal,
            widgetId,
            editorial: props.editorial,
            name: props.name,
            reviews: props.reviews,
            battle: props.battle,
            placeholder: props.placeholder,
            language: props.language,
            star: props.star,
            widget: props.widget,
            blockLayout: props.blockLayout,
          }),
        }),
      );
    },
    [
      props.battle,
      props.blockLayout,
      props.editorial,
      props.language,
      props.name,
      props.placeholder,
      props.reviews,
      props.star,
      props.widget,
      widgetId,
    ],
  );

  return {
    sendAnalytics,
  };
};
